import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { ProdutosCarrinhoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoContainer";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { CheckoutPaper } from "../../../../components/CheckoutPaper";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { CarrinhoMobilePaper } from "../../styles";
import { CategoriasContainer, ProdutosPaper } from "./styles";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { useOperacaoEdicaoContext } from "../../../../contexts/OperacaoEdicaoContext";
import { ProdutosCarrinhoEdicaoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoEdicaoContainer";
import { Print } from "@mui/icons-material";
import { BotoesAcoesCheckout } from "../../../../components/BotoesAcoesCheckout";
import { FidelidadeCardsWrapper } from "../../../../components/FidelidadeCardsWrapper";

export const OperacaoEdicaoSimples = () => {
    const { modeloTela } = useTamanhoTela();
    const { categorias, isLoading } = useFetchCategorias();
    const {
        adicionarProduto,
        adicionarProdutosCombo,
        alterarPagamentos,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        fecharPedido,
        loading,
        cancelarPedido,
        editarProduto,
        numeroTotalItens,
        pedido,
        abrirDrawerPagamento,
        abrirDrawerDividir,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        switchNotaFiscal,
        handleSwitchNotaFiscal,
        configuracaoNFCe,
        abrirModalImpressao,
        cupons,
        abrirDrawerCupons,
        aplicarCupom
    } = useOperacaoEdicaoContext();

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    }
    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >

            <Grid item xs={12} md={9} lg={9}>
                <ProdutosPaper variant="outlined">
                    <CategoriasContainer>
                        <OperacaoCategoriasProdutosContainer
                            categorias={categorias}
                            adicionarProduto={adicionarProduto}
                            adicionarProdutosComboExterno={adicionarProdutosCombo}
                            contexto={TipoPedido.simples}
                            carrinhoContainer={
                                <ProdutosCarrinhoEdicaoContainer
                                    categorias={categorias}
                                    produtosCarrinho={pedido?.produtos ?? []}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            }
                        />
                    </CategoriasContainer>
                </ProdutosPaper>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
                {pedido && (
                    <CheckoutPaper
                        loading={loading}
                        pedidoSelecionado={pedido?.uuid}
                        valorTotalPedido={pedido.valorTotal}
                        numeroTotalItens={numeroTotalItens}
                        numeroPedidoDiario={pedido?.numeroPedidoDiario}
                        opcoes={[
                            {
                                titulo: "Concluir",
                                funcao: fecharPedido,
                                atalho: "F8"
                            },
                            {
                                titulo: "Dividir pedido",
                                funcao: abrirDrawerDividir
                            },
                            {
                                titulo: "Dividir pagamento",
                                funcao: abrirDrawerPagamento
                            },
                            {
                                titulo: "Cancelar",
                                funcao: cancelarPedido,
                                desabilitado: false
                            }
                        ]}
                    >
                        <FidelidadeCardsWrapper
                            cliente={pedido?.cliente}
                            cupons={cupons}
                            aplicarCupom={aplicarCupom}
                            adicionarProduto={adicionarProduto}
                            categorias={categorias || []}
                            produtos={pedido?.produtos || []}
                        />
                        <MetodoPagamentoSelect
                            pagamento={pedido.pagamentos ? pedido.pagamentos[0] : undefined}
                            onChange={handleAlterarPagamento}
                            valorTotal={pedido.valorTotal}
                        />
                        <BotoesAcoesCheckout
                            switchImprimirAutomatico={switchImprimirAutomatico}
                            handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                            switchNotaFiscal={switchNotaFiscal}
                            handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                            configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                            quantidadeCupons={cupons.length}
                            abrirDrawerCupons={abrirDrawerCupons}
                            abrirModalComandas={abrirModalImpressao}
                        />
                        {modeloTela == "mobile" && (pedido.produtos && pedido.produtos?.length > 0) && (
                            <CarrinhoMobilePaper variant="outlined" sx={{ marginTop: "1rem" }}>
                                <ProdutosCarrinhoEdicaoContainer
                                    categorias={categorias}
                                    produtosCarrinho={pedido?.produtos ?? []}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            </CarrinhoMobilePaper>
                        )}
                    </CheckoutPaper>
                )}
            </Grid>
        </Grid>
    );
}